import { HomeOutlined, ReloadOutlined } from "@ant-design/icons";
import { Button, Result, Typography } from "antd";
import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router-dom";

// Global fallback rendered by React Router when a route element (or loader)
// throws. Without it, React Router shows the raw "Unexpected Application
// Error!" screen. Wired as `errorElement` on the top-level routes.
export function RouteErrorBoundary() {
	const error = useRouteError();
	const navigate = useNavigate();

	let title = "Kutilmagan xatolik";
	let subTitle = "Sahifani ko'rsatishda xatolik yuz berdi. Iltimos, qayta urinib ko'ring.";

	if (isRouteErrorResponse(error)) {
		title = `${error.status} — ${error.statusText}`;
		subTitle = (error.data as string | undefined) ?? subTitle;
	} else if (error instanceof Error) {
		subTitle = error.message || subTitle;
	}

	return (
		<Result
			status="error"
			title={title}
			subTitle={subTitle}
			extra={[
				<Button
					key="home"
					type="primary"
					icon={<HomeOutlined />}
					onClick={() => navigate("/", { replace: true })}
				>
					Bosh sahifaga
				</Button>,
				<Button key="reload" icon={<ReloadOutlined />} onClick={() => window.location.reload()}>
					Qayta yuklash
				</Button>,
			]}
		>
			{import.meta.env.DEV && error instanceof Error && error.stack ? (
				<Typography.Paragraph>
					<pre className="max-h-64 overflow-auto whitespace-pre-wrap text-xs text-gray-500">
						{error.stack}
					</pre>
				</Typography.Paragraph>
			) : null}
		</Result>
	);
}
